import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

export const useAuth = (): any => {
  const { isAuth, setIsAuth, saveAuthCookies } = useContext(AuthContext);
  return { isAuth, setIsAuth, saveAuthCookies };
};
